var html = $("html");

$(function() {
  menu();
  video();
  ghostSearch();
  gallery();
  search();
});

function menu() {
  // This will highlight the current menu item
  $(".menu-item").each(function() {
    if (
      $(this)
        .children("a")
        .eq(0)
        .attr("href") == window.location.href
    ) {
      $(this).addClass("menu-item-current");
    }
  });
}

function video() {
  "use strict";
  $(".gh-content").fitVids();
}

function search() {
  $("#ghost-search-field")
    .focusin(function() {
      setTimeout(function() {
        $("#ghost-search-results").show();
      }, 500);
    })
    .focusout(function() {
      setTimeout(function() {
        $("#ghost-search-results").hide();
      }, 500);
    });
}

function gallery() {
  var images = document.querySelectorAll(".kg-gallery-image img");
  images.forEach(function(image) {
    var container = image.closest(".kg-gallery-image");
    var width = image.attributes.width.value;
    var height = image.attributes.height.value;
    var ratio = width / height;
    container.style.flex = ratio + " 1 0%";
  });
}

function ghostSearch() {
  new GhostSearch({
    key: ghostSearchApiKey,
    url: ghostSearchUrl,
    template: function(result) {
      let url = [location.protocol, "//", location.host].join("");
      let localDate = new Date(result.created_at).toLocaleDateString();
      let tag =
        result.tags && result.tags[0]
          ? result.tags[0].name
          : '{{t "Uncategorized"}}';
      return `
            <a class="search-result-item" href="${url}/${result.slug}/">
              <div class="search-result-left">
                <div class="search-result-title">${result.title}</div>
                <div class="search-result-tag">${tag}</div>
              </div>
              <div class="search-result-date">${localDate}</div>
            </a>`;
    },
    options: {
      keys: ["title"],
      limit: 5,
    },
    api: {
      resource: "posts",
      parameters: {
        fields: ["title", "slug", "created_at"],
        formats: "plaintext",
        threshold: -3500,
        allowTypo: true,
        include: "tags",
      },
    },
  });
}
